import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import {  endPoints, MIDDLEWARE_SLUG } from '../../apis/apiEndPoints';
import { MasterDataType, UserDataType } from '../../types/dataTypes';
import { ILocationResponse } from '../../types/campaign.types';

const DOMAIN = window.location.origin

export const locationServiceApi = createApi({
  reducerPath: "locationServiceApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${DOMAIN}`
    // baseUrl: `${window.location.origin}${MIDDLEWARE_SLUG}/middleware`,
  }),
  endpoints: (builder) => ({
    // to fetch job locations - useGetLocationDataQuery
    getLocationData: builder.query<
      ILocationResponse,
      { userData: MasterDataType }
    >({
      query: ({ userData }) => ({
        url: `${endPoints.LOCATION_LIST}`,
        method: "GET",
        params: {
          channelId: userData.channelId,
          subChannelId: userData.subChannelId,
          random: userData.recruiterId,
        },
        headers: {
          domain: DOMAIN,
        },
        withCredentials: true,
      }),
    }),
  }),
});

export const {
  useGetLocationDataQuery

} = locationServiceApi;

